import { composables } from "@orange-marmalade/paginate-this";
import { SUCCESS } from "LIB/submission/constants";
import api from "APP_ROOT/api";
import { PART } from "MODULES/parts/constants";
import { EMAIL, ID, NAME } from "APP_ROOT/constants";
import { modifyFormDataForContact } from "MODULES/parts/components/Detail/PurchaseOrders/Create/Create";

export const pageActions = composables({
  listId: "part/incomingQuoteLineItems"
});

export function createIncomingQuote(data, afterCreate = () => {}) {
  return (dispatch, getState) => {
    let partId = getState().partDetail.getIn([PART, ID]);
    if (!partId) {
      partId = data.incoming_quote_line_item.part_id;
    }

    if (
      data.company &&
      data.company.website &&
      ![NAME, EMAIL].some(f => data.contact && data.contact[f])
    ) {
      data.portal_purchase = true;
    }

    modifyFormDataForContact(data);

    return api.parts.incomingQuotes.create(partId, data).then(resp => {
      afterCreate(resp.data, data.send_quote);
      return SUCCESS;
    });
  };
}

export function bulkCreateIncomingQuote(data) {
  return (dispatch, getState) => {
    let partId = getState().partDetail.getIn([PART, ID]);
    if (!partId) {
      partId = data.incoming_quote_line_item.part_id;
    }

    return api.parts.incomingQuotes
      .bulkCreate(partId, data)
      .then(() => SUCCESS);
  };
}



// WEBPACK FOOTER //
// ./app/modules/parts/actions/incomingQuotes.js